module.exports = __webpack_public_path__ + "img/Weapon_140.1a70461b.png";